import * as Sentry from "@sentry/react";

// ─── Wallet / Login ───────────────────────────────────────────────────────────

export function sentryWalletBreadcrumb(
  action: "open_modal" | "connect_attempt" | "sign_attempt" | "sign_success" | "disconnect",
  extra?: Record<string, unknown>,
) {
  Sentry.addBreadcrumb({
    category: "wallet",
    message: `wallet.${action}`,
    level: "info",
    data: extra,
  });
}

export function sentryWalletError(error: unknown, action: string, extra?: Record<string, unknown>) {
  Sentry.captureException(error, {
    tags: { section: "login-vi", action },
    extra,
  });
}

// ─── Tab Sành ─────────────────────────────────────────────────────────────────

export function sanhTabBreadcrumb(tabName: string) {
  Sentry.addBreadcrumb({
    category: "sanh",
    message: `sanh.tab_change → ${tabName}`,
    level: "info",
    data: { tab: tabName },
  });
}

export function sanhError(error: unknown, context: string, extra?: Record<string, unknown>) {
  Sentry.captureException(error, {
    tags: { section: "sanh", context },
    extra,
  });
}

// ─── Generic ──────────────────────────────────────────────────────────────────

export { Sentry };
